import { useState, useCallback, useEffect } from 'react';
import {
  chatWebsocketService,
  ChatMessage,
} from '@/services/websocket/chat-websocket-service';

export const useChatWebSocket = () => {
  const [isConnected, setIsConnected] = useState(
    chatWebsocketService.isConnected(),
  );

  // Subscribe to connection state changes to keep isConnected in sync
  useEffect(() => {
    const unsubscribe = chatWebsocketService.onConnectionStateChange(
      (state) => {
        setIsConnected(state.isConnected);
      },
    );
    return unsubscribe;
  }, []);

  const connect = useCallback(async (chatSocketUrl: string) => {
    try {
      await chatWebsocketService.connect(chatSocketUrl);
    } catch (error) {
      console.error('Failed to connect to chat WebSocket:', error);
    }
  }, []);

  const disconnect = useCallback(() => {
    chatWebsocketService.disconnect();
  }, []);

  const subscribe = useCallback(
    (messageType: string, callback: (message: ChatMessage) => void) => {
      return chatWebsocketService.subscribe(messageType, callback);
    },
    [],
  );

  const subscribeToAll = useCallback(
    (callback: (message: ChatMessage) => void) => {
      return chatWebsocketService.subscribeToAll(callback);
    },
    [],
  );

  const send = useCallback((message: string | object) => {
    chatWebsocketService.send(message);
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      chatWebsocketService.disconnect();
    };
  }, []);

  return {
    isConnected,
    connect,
    disconnect,
    subscribe,
    subscribeToAll,
    send,
  };
};
